<div class="warranty-term-block">
    <div class="row m-0">
        <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="tab-container">
                <div class="tab-details ">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 warranty-term-title">
                            <div class="">{{ 'common.text_warranty_terms_highway_information' | cxTranslate }}</div>
                        </div>
                        <div class="col-xs-12 col-sm-6 warranty-term-title off-tem-title">
                            <div class="">{{ 'common.text_warranty_terms_highway_off' | cxTranslate }} </div>
                        </div>
                    </div>
                    <div class="row warranty-term-row-content">
                        <div class="col-xs-12 col-sm-6 warranty-term-content">

                            <p class="mt-3">{{ 'common.text_warranty_terms_highway_applications' | cxTranslate }} </p>
                            <ul class="ml-4">
                                <li>{{ 'common.text_warranty_terms_highway_applications' | cxTranslate }}  </li>
                                <li>{{ 'common.text_warranty_terms_ineterstate_truck' | cxTranslate }} </li>
                                <li>{{ 'common.text_warranty_terms_pick_delivery' | cxTranslate }} </li>
                                <li>{{ 'common.text_warranty_terms_inter_city' | cxTranslate }} </li>
                                <li>{{ 'common.text_warranty_terms_charter_bus' | cxTranslate }} </li>
                                <li>{{ 'common.text_warranty_terms_school_bus' | cxTranslate }} </li>
                                <li>{{ 'common.text_warranty_terms_shuttle_bus' | cxTranslate }} </li>
                                <li>{{ 'common.text_warranty_terms_motor_home' | cxTranslate }} </li>
                                <li>{{ 'common.text_warranty_terms_firetruck_home' | cxTranslate }} </li>
                            </ul>
                        </div>
                        <div class="col-xs-12 col-sm-6 warranty-term-content">
                            <div
                                class="col-xs-12 col-sm-6 warranty-term-title mobile-warranty-term-title mt-3">
                                <div class="">{{ 'common.text_warranty_terms_highway_off' | cxTranslate }} </div>
                            </div>
                            <p class="mt-3">{{ 'common.text_warranty_terms_app_frequency' | cxTranslate }}
                            </p>
                            <ul class="ml-4">
                                <li>{{ 'common.text_warranty_terms_transit_bus' | cxTranslate }}</li>
                                <li>{{ 'common.text_warranty_terms_refuse_hauler' | cxTranslate }}</li>
                                <li>{{ 'common.text_warranty_terms_dump_truck' | cxTranslate }}</li>
                                <li>{{ 'common.text_warranty_terms_cement_mixer' | cxTranslate }}</li>
                                <li>{{ 'common.text_warranty_terms_logging_vehicle' | cxTranslate }}</li>
                                <li>{{ 'common.text_warranty_terms_yard_truck' | cxTranslate }}</li>
                                <li>{{ 'common.text_warranty_terms_other_vehicle' | cxTranslate }}</li>
                            </ul>
                        </div>
                        <div class="clearfix"></div>
                        <div class="warranty-term-bottom-note w-100">
                            <p class="px-4">{{ 'common.text_warranty_terms_some_parts' | cxTranslate }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
